export const apidefinitions = {
    CountryNames: 'api/v1/config/getAllCountries',
    IncomeSource: 'api/v1/config/getIncomeSource',
    loginUrl: 'api/v1/portal/portalLogin',
    OTPRequestUrl: 'api/v1/onboarding/sendEmailOTP',
    OTPValidateUrl: 'api/v1/onboarding/verifyEmailOTP',
    ResetPassword: 'api/v1/portal/forgotPassword',
    ChangePortalUserPassword: 'api/v1/portal/changePortalUserPassword',
    GetCifDetails: 'api/v1/portal/getCIFDetails',
    GetCorporateUsers: 'api/v1/portal/getCorporateUsersV2',
    GetUserProfile: 'api/v1/portal/getUserProfile',
    GetCompanyAccounts: 'api/v1/portal/getCompanyAccounts',
    UpdateUserProfile: 'api/v1/portal/updateUserProfile',
    UpdateUserMatrix: 'api/v1/portal/updateCorporateUserApprovalMatrixV2',
    CreateCustomer: 'api/v1/portal/createCorporateUserV2',
    GetRejectedCustomers: 'api/v1/portal/getRejectedCorporateUserV2',
    GetPendingCustomers: 'api/v1/portal/getPendingCorporateUsersV2',
    ApproveOrRejectCustomerProfile: 'api/v1/portal/approveOrDisapproveUserProfile',
    ApproveOrRejectCustomerPermissions: 'api/v1/portal/approveOrDisapproveAllCustomerMatrixV2',
    ActivateOrDeactivateRequest: 'api/v1/portal/activateOrDeactivateUserRequest',
    ApproveOrRejectCustomerActivationRequest: 'api/v1/portal/approveOrRejectActivateOrDeactivateUserRequest',
    GetLeads: 'api/v1/portal/getCompanyRegistrationRequests',
    ApproveOrRejectLead: 'api/v1/portal/approveOrDisapproveCompanyRegistrationRequest',
    GetAllPortalUsers: 'api/v1/portal/getAllPortalUsers',
    UpdatePortalUser: 'api/v1/portal/updatePortalUser',
    ResetPortalUserPassword: 'api/v1/portal/resetPortalUserPassword',
    DeactivatePortalUser: 'api/v1/portal/deactivatePortalUser',
    CreatePortalUser: 'api/v1/portal/createPortalUser',
    GetRetailCustomer: 'api/v1/portal/getRetailCustomer',
    GetCustomerIdentityDetailsByEmail: 'api/v1/portal/getCustomerIdentityDetailsByEmail',
    GetRetailCustomersList: 'api/v1/portal/getRetailCustomerList',
    getClientClasificationslist: 'api/v1/portal/getClientClasificationslist',
    ResetRetailCustomerPassword: 'api/v1/portal/resetRetailUserPassword',
    GetServiceTypes: 'api/v1/portal/getServiceRequestTypes',
    GetServiceRequests: 'api/v1/portal/getServiceRequests',
    ResolveTicket: 'api/v1/portal/resolveServiceRequest',
    GetMakerCheckerFunctions: 'api/v1/portal/getMakerCheckerFunctions',
    GetHoldQueueReport: 'api/v1/portal/getHoldQueueAuditLogReport',
    GetUserManagementReport: 'api/v1/portal/getUserManagementReport',
    GetUserPermissionReport: 'api/v1/portal/getUserMatrixReport',
    ApproveOrRejectPortalUser: 'api/v1/portal/approveOrDisapprovePortalUser',
    getDecisionTable:'api/v1/portal/getDecisionTable',
    getDecisionDataTypes:'api/v1/portal/getDecisionDataTypes',
    getDecisionRules:'api/v1/portal/getDecisionRules',
    getDecisionParameters:'api/v1/portal/getDecisionParameters',
    updateDecisionParameter:'api/v1/portal/updateDecisionParameter',
    updateDecisionTimes:'api/v1/portal/updateDecisionTimes',
    updateDecisionTable:'api/v1/portal/updateDecisionTable',
    createInvitation:'api/v1/portal/createInvitation',
    getSwiftTransfers:'api/v1/portal/getSwiftTransfers',
    scanBeneficiary:'api/v1/portal/scanBeneficiary',
    updateSwiftTransfer:'api/v1/portal/updateSwiftTransfer',
    getInvitation:'api/v1/portal/getInvitation',
    getCustomerDeatils:"api/v1/portal/getCustomersDetails",
    getClientClasificationCustomersDetails:"api/v1/portal/getClientClasificationCustomersDetails",
    saveCustomerDeatils:"api/v1/portal/updateCustomersDetails",
    GetProspectiveLeads:'api/v1/portal/getLeads',
    UpdateProspectiveLead:'api/v1/portal/UpdateLead',
}